
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SelectComponent from '../shared/Select.vue';
import TextField from '@/components/shared/TextField.vue';

@Component<ReasonSelect>({
	components: {
		SelectComponent,
		TextField
	}
})
export default class ReasonSelect extends Vue {
	@Prop({ type: Array, required: true }) private reasons!: string[];
	@Prop({ type: String, required: true }) private i18nPrefix!: string;
	@Prop({ type: String, required: true }) private id!: string;
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;

	@Watch('selectedReason')
	@Watch('customReason')
	private onReasonChange(): void {
		// The note is the custom text when "Other" is selected, the localized reason text otherwise
		this.$emit('change', {
			value: this.selectedReason.value,
			note: this.selectedReason.value === 'other' ? this.customReason : this.selectedReason.text
		});
	}

	private customReason: string = '';
	private selectedReason: { text: string; value: string; } = { text: '', value: '' };

	/**
	 * The dropdown items, localized from the reason keys.
	 *
	 * @return {{ text: string; value: string; }[]}
	 */
	private get reasonItems(): { text: string; value: string; }[] {
		return this.reasons.map(reason => {
			return {
				value: reason,
				text: this.$t(`${this.i18nPrefix}.${reason}`)
			};
		});
	}
}
